import { push, ref, update } from "firebase/database";
import { database } from "../../../Utils/firebase";
import GetInvoiceDataFirebase from "./GetInvoiceDataFirebase";
import EditItemDataInFirebase from "../Items/EditItemDataInFirebase";
import EditCustomerData from "../Customers/EditCustomerData";

const EditInvoiceDataInFirebase = async (state, dispatch, id, invoiceData, userId) => {


    const USERID = userId ? userId : state?.USERID

    console.log("userid", USERID);

    if (!USERID) return null;

    try {

        const formatItems = (rawItems) => {
            return rawItems.map(i => ({
                // amount: i?.amount?.toString() || "0.00",
                // billId: invoiceData?.id?.toString() || "",
                // companyId: invoiceData?.companyId?.toString() || "",
                // creationDate: invoiceData.creationDate.toString() || new Date().getTime().toString(),
                // isSalesReturnKey: "",
                // itemId: "",
                // name: i?.name || "",
                // price: i?.price?.toString() || "",
                // quantity: i?.quantity?.toString() || "",
                // subtitle: i.subtitle || "",
                // updateDate: new Date().getTime().toString(),
                itemId: i?.itemId || "",
                itemAddedDate: new Date().getTime().toString() || "",
                price: i?.price?.toString() || "",
                quantity: i?.quantity?.toString() || "",
            }));
        };

        const actorName = state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest";

        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${USERID}/billInvoice/${id}`);

        // Push new invoice data
        await update(userRef, {
            updatedBy: actorName,
            companyId: invoiceData?.companyId?.toString() || "",
            creationDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            customInvoiceId: invoiceData?.customInvoiceId?.toString() || "",
            customerId: invoiceData?.customerId?.toString(),
            date: (invoiceData?.date && !isNaN(invoiceData.date)) ? invoiceData.date.toString() : "",
            discountAmount: invoiceData?.discountAmount?.toString() || "0.00",
            discountPercetage: invoiceData?.discountPercetage?.toString() || "0",
            dueDate: (invoiceData?.dateDue && !isNaN(invoiceData.dateDue)) ? invoiceData.dateDue.toString() : "",
            gstAmount: invoiceData?.gstAmount?.toString() || "0.00",
            pstAmount: invoiceData?.pstAmount?.toString() || "0.00",
            pstPercentage: invoiceData?.pstPercentage?.toString() || "0",
            gstPercetage: invoiceData?.gstPercentage?.toString() || invoiceData?.gstPercetage?.toString() || "0",
            id: invoiceData?.id?.toString() || "",
            invoiceId: invoiceData?.invoiceId?.toString() || "",
            isigst: invoiceData?.isigst || invoiceData?.igst == true ? "true" : "false",
            note: invoiceData?.note?.toString() || "",
            paidFlagKey: invoiceData?.isPaid ? "true" : "false",
            platform: "website",
            totalAmount: invoiceData?.totalAmount?.toString() || "",
            updateDate: invoiceData?.creationDate?.toString() || new Date().getTime().toString(),
            version: process.env.REACT_APP_VERSION,
            items: formatItems(invoiceData?.items),
            shippingaddress: invoiceData?.shippingaddress || "",
            currency: invoiceData?.currency?.toString() || "",
            dialCode: invoiceData?.dialCode?.toString() || "",
            phone: invoiceData?.phone?.toString() || "",
            email: invoiceData?.email?.toString() || "",
            address: invoiceData?.address?.toString() || "",
            customer: invoiceData?.customer?.toString() || "",
            customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
        });

        const customer = {
            companyId: invoiceData?.companyId?.toString() || "",
            customer: invoiceData?.customer?.toString() || "",
            customerGSTNo: invoiceData?.customerGSTNo?.toString() || "",
            phone: invoiceData?.phone?.toString() || "",
            email: invoiceData?.email.toString() || "",
            createdAt: invoiceData.creationDate.toString() || new Date().getTime().toString(),
            updatedAt: invoiceData.creationDate.toString() || new Date().getTime().toString(),
            invoiceCount: "1",
            invoices: [invoiceData?.invoiceId?.toString()],
            outstanding: invoiceData?.totalAmount?.toString() || "0",
            totalAmount: invoiceData?.totalAmount?.toString() || "0",
            totalPaid: "0",
            address: invoiceData?.address?.toString() || ""
        }

        // await EditCustomerData(state, dispatch, customer)

        // await EditItemDataInFirebase(state, dispatch, formatItems(invoiceData?.items))

        // Fetch updated invoice data
        await GetInvoiceDataFirebase(state, dispatch);

        return { success: true, message: "Invoice updated successfully!" };
    } catch (error) {
        return { success: false, message: error };
    }
};

export default EditInvoiceDataInFirebase;
